import React, { useState, useEffect } from 'react'
import { useSelector,  useDispatch } from 'react-redux'
import { Card, Table } from '../../onestep-library/BaseUI/'
import EditRecurringCharge from './components/EditRecurringCharge'
import RecurringChargeListing from './components/RecurringChargeListing'
import { Elements } from 'react-stripe-elements'
import { fetchRecurringCharges } from './actions'

function RecurringCharges(props){
  const dispatch = useDispatch()
  const {recurringCharges, ui} = useSelector(state=>state.recurringCharges)
  const { loading } = ui
  const newRecurringChargeForm = useSelector(state=>state.newRecurringChargeForm)

  useEffect(()=>{
    dispatch(fetchRecurringCharges())
    setTimeout(()=>{
      dispatch({type: 'UPDATE_RECURRING_CHARGES_UI', payload: {loading: false}})
    },1000)
  },[])

  function setNewRecurringChargeVisiblity(){
    dispatch({type: 'UPDATE_NEW_RECURRING_CHARGE_UI', payload: {show: true}})
  }


  return(
    <div>
      <Elements>
        <EditRecurringCharge/>
      </Elements>
      <Card
        isLoading={loading}
        visible={recurringCharges.length > 0}
        className="mt-4"
        title="Recurring">
        <Table 
          columnNames={['Next Due On', 'Memo','Amount','First Due Date','Interval','Ends','Payment Info', '']}
          rows={recurringCharges}
          Row={RecurringChargeListing}
          zeroCaseMessage="No Recurring Charges"/>
      </Card>
    </div>
  )
}

export default RecurringCharges